import { MutationTree } from 'vuex'
import { UI } from './types'

export const mutations: MutationTree<UI> = {
  setDisconnectDialogValue(state, payload) {
    state.disconnectDialogValue = payload
  },
  setDisconnectDialogMessage(state, payload) {
    state.disconnectDialogMessage = payload
  },
  setSnackbar(state, payload) {
    state.snackbar.show = payload.show
    state.snackbar.color = payload.color
    state.snackbar.text = payload.text
    state.snackbar.timeout = payload.timeout
  },
  closeSnackbar(state) {
    state.snackbar.show = false
  }
}
